import { render, staticRenderFns } from "./dr-process-component.vue?vue&type=template&id=7bd41d48&scoped=true"
import script from "./dr-process-component.vue?vue&type=script&lang=js"
export * from "./dr-process-component.vue?vue&type=script&lang=js"
import style0 from "./dr-process-component.vue?vue&type=style&index=0&id=7bd41d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd41d48",
  null
  
)

export default component.exports